import { render, staticRenderFns } from "./activitiesTab.vue?vue&type=template&id=865b54ae"
import script from "./activitiesTab.vue?vue&type=script&lang=js"
export * from "./activitiesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports